// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__7veeV","label":"Textarea_label__5lIdz","textarea":"Textarea_textarea__CfnPd","invalid":"Textarea_invalid__fk66e"};